<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
                <h3 class="font-weight-bold">Appointment Summary Report</h3>
                <div class="text-xs-right">
                    <export-summary-report-button model="appointment" :export-date="range"
                                                  v-if="$oauth.checkIfHasPermission(['export appointment-summary-report'])"/>
                  <refresh-button :click-function="updateByOffice"></refresh-button>
                </div>
            </v-flex>
            <v-flex xs12>

                <v-card>
                    <v-layout class="py-1 mx-2" row wrap>
                        <v-flex xs6 class="d-flex align-center">
                            <custom-date-range-picker @change="updateByOffice"
                                                      v-model="range"/>
                        </v-flex>
<!--                        <v-flex xs6>-->
<!--                            <v-autocomplete-->
<!--                                    :items="offices"-->
<!--                                    flat-->
<!--                                    hide-details-->
<!--                                    item-text="name"-->
<!--                                    item-value="id"-->
<!--                                    label="Office"-->
<!--                                    prepend-inner-icon="filter_list"-->
<!--                                    solo-->
<!--                                    v-model="office"-->
<!--                                    @change="updateByOffice"-->
<!--                            />-->
<!--                        </v-flex>-->

                    </v-layout>

                    <v-divider/>
                    <v-card-text class="pa-0">
                        <v-simple-table
                                class="elevation-0 pb-6"
                                v-if="$oauth.checkIfHasPermission(['read revenue-summary-report'])"
                        >
                            <thead>
                            <tr>
                                <th class="text-center">S.N</th>
                                <th class="text-left">Date</th>
                                <th class="text-left">Tourist Appointment</th>
                                <th class="text-left">Non-Tourist Appointment</th>
                                <th class="text-left">Business Appointment</th>
                                <th class="text-left">Dependent Appointment</th>
                                <th class="text-center font-weight-bold">Total</th>
                            </tr>
                            </thead>
                            <tbody v-if="appointment_data.length>0">
                            <tr v-for="(item,i) in appointment_data">
                                <td class="text-center">{{i+1}}</td>
                                <td >{{item.date}}</td>
                                <td >{{item.tourist_count}} / {{item.tourist_token}}</td>
                                <td >{{item.non_tourist_count}} / {{item.non_tourist_token}}</td>
                                <td >{{item.business_count}}</td>
                                <td >{{item.dependent_count}}</td>
                                <td class="font-weight-bold text-center">{{item.total_count}}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td><h3 class="text-center">No record found</h3></td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import CustomDateRangePicker from "../../components/CustomDateRangePicker";
    import {commonStoreMixin} from "../../mixins/commonStoreMixin";
    import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
    import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
    import ExportButton from "../../components/ExportButton";
    import Http from "axios";
    import {VERSIONED_API_URL} from "../../config/config";
    import RefreshButton from "@/components/RefreshButton";

    const APPOINTMENT_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/appointment/summary-report`;

    export default {
        name: "AppointmentSummaryReport",
        data() {
            return {
                appointment_data:[],
                range:{},
                // office:null,
            };
        },
        components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
        mixins: [commonStoreMixin],
        computed: {
            ...mapGetters({
                loading: "ArrivalDepartureReport/reportLoading",
                // offices: "OfficeList/offices",
            }),
            from_main_office() {
                return this.$store.state.AuthUser.user.from_main_office;
            },
        },
        methods: {
            ...mapActions({
                fetchOffices: 'OfficeList/fetchData',
            }),
            updateByOffice(){
                let params = {};
                if(Object.keys(this.range).length > 0)
                    params.date_range = this.range;
                if(this.office)
                    params.office = this.office;

                Http.get(APPOINTMENT_SUMMARY_REPORT_URL, {
                    params:params
                })
                    .then((res)=>{
                        this.appointment_data = res.data.data;
                        // this.getData();
                    })
                    .catch(()=>{
                        this.$store.commit('Notification/showError','Something went wrong');
                    });
            }


        },
        mounted() {
            // this.fetchOffices();
            Http.get(APPOINTMENT_SUMMARY_REPORT_URL)
                .then((res)=>{
                    this.appointment_data = res.data.data;
                    // this.office = res.data.office
                    // this.getData();
                })
                .catch(()=>{

                });

            this.range = {
                // start: new Date().toISOString().substr(0, 10),
                // end: new Date().toISOString().substr(0, 10)
            }
        }
    }
</script>
